module.exports = __webpack_public_path__ + "media/4.bf06bb8f.mp3";